import { Box, Grid, Stack } from '@mui/material';

import { useTitle } from '@/hooks';

import {
  Calendar,
  ExploreChangeGPS,
  LatestWebinar,
  RecentWork,
  WhatsNew,
} from '../components';

export const Home = () => {
  useTitle('Home');

  return (
    <Box px={4} py={3}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Stack spacing={3}>
            <LatestWebinar />
            <ExploreChangeGPS />
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <Stack spacing={3}>
            <Calendar />
            <RecentWork />
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <WhatsNew />
        </Grid>
      </Grid>
    </Box>
  );
};
